import { t } from '../i18n';
import {
  FILO,
  INCLINAZIONE,
  LATO,
  ZONE,
  type Filo,
  type Inclinazione,
  type Lato,
  type Zone,
} from '../config/constants';
import type { DrillTarget } from './repEvaluator';

/** Display label for a lato value (d'arte term, stays Italian). */
export function latoLabel(l: Lato): string {
  return l === LATO.mandritto ? t('latoMandritto') : t('latoRiverso');
}

/** Display label for an inclinazione value (reuses the cut-rose terms where they exist). */
export function inclinazioneLabel(i: Inclinazione): string {
  switch (i) {
    case INCLINAZIONE.fendente:
      return t('cutFendente');
    case INCLINAZIONE.sgualembro:
      return t('incSgualembro');
    case INCLINAZIONE.tondo:
      return t('incTondo');
    case INCLINAZIONE.ridoppio:
      return t('incRidoppio');
    case INCLINAZIONE.montante:
      return t('cutMontante');
  }
}

/** Display label for a filo value. */
export function filoLabel(f: Filo): string {
  return f === FILO.dritto ? t('filoDritto') : t('filoFalso');
}

/** Display label for a pell zone (d'arte zone names). */
export function zoneLabel(z: Zone): string {
  switch (z) {
    case ZONE.head:
      return t('zoneHead');
    case ZONE.shoulder:
      return t('zoneShoulder');
    case ZONE.chest:
      return t('zoneChest');
    case ZONE.flank:
      return t('zoneFlank');
    case ZONE.leg:
      return t('zoneLeg');
  }
}

/**
 * Human-readable prescriptive target, e.g. "mandritto fendente · testa". Unpinned axes
 * ("qualsiasi") are omitted; an all-qualsiasi target reads as "qualsiasi colpo".
 */
export function drillTargetName(target: DrillTarget): string {
  const parts: string[] = [];
  if (target.lato) parts.push(latoLabel(target.lato));
  if (target.inclinazione) parts.push(inclinazioneLabel(target.inclinazione));
  if (target.filo) parts.push(`di filo ${filoLabel(target.filo)}`);
  const colpo = parts.length > 0 ? parts.join(' ') : t('optAny');
  return target.zone ? `${colpo} · ${zoneLabel(target.zone)}` : colpo;
}
